import { api } from '../app/api.js';
import { sanitise } from "../helpers/sanitiser.js";

export default {
    template: `
        <div class="section darker fh">
            <div class="content legal">
              <h1>Terms and Conditions</h1>
              <p id="terms-loading">Loading...</p>
              <p id="terms-error" class="terms-error"></p>
              <p id="terms-meta" class="dark"></p>
              
              <div id="terms-content" style="display: none;"></div>
            </div>
        </div>
    `,

    $loading: null,
    $errors: null,
    $content: null,
    $meta: null,

    async onMount() {
        this.$loading = document.getElementById('terms-loading');
        this.$errors = document.getElementById('terms-error');
        this.$content = document.getElementById('terms-content');
        this.$meta = document.getElementById('terms-meta');

        this.load_terms();
    },
    async load_terms() {
        this.$loading.style.display = 'block';
        this.$errors.style.display = 'none';
        this.$content.style.display = 'none';

        api.get({
            url: '/legal/terms',
            success: response => {
                const date = new Date(response.date_created * 1000);

                this.$content.innerHTML = sanitise(response.description);
                this.$meta.textContent = `Version ${response.version} — Created on ${date.toLocaleDateString()}`;

                this.$loading.style.display = 'none';
                this.$content.style.display = 'block';
            },
            error: () => {
                this.$errors.textContent = 'Failed to load terms. Please try again later.';
                this.$loading.style.display = 'none';
                this.$errors.style.display = 'block';
            }
        })
    }
};
